import { render, staticRenderFns } from "./ChildrenStep.vue?vue&type=template&id=1550d7f9&"
import script from "./ChildrenStep.vue?vue&type=script&lang=js&"
export * from "./ChildrenStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports